// extracted by mini-css-extract-plugin
export default {"AvatarStack":"assignees-group-header-label-module__AvatarStack--WyhZX","AggregateLabels":"assignees-group-header-label-module__AggregateLabels--hc4oR"};